import React, { Component } from 'react';
import classNames from 'classnames';
import { getUsersForWlf, loadCSS } from "./actions";
import _ from 'underscore';
import { CookieWrap as Cookies } from "../helper/cookie-wrap";
import { urlParamToObj, objToUrlParam } from "../../lib/url-util";
import './home.scss';
import {is_production_mode} from "../helper/execute-mode";
import {config_to_url} from "../helper/url";
import {broadcast_message} from "../app/popup_window_factory";
import {WINDOW_EVENTS} from "../app/window_events";

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedWlf: props.wlfs ? props.wlfs[0] : null,
      users: [],
      wlf_admins: [],
      super_admins: [],
    };
  }

  componentDidMount = () => {
    const cookies = new Cookies();
    cookies.remove('wlf', { path: '/' });
    cookies.remove('token', { path: '/' });
    this.props.logout();
    const config = this.props.app.config;
    if (config) {
      const origin = config_to_url(this.props.app.config);
      broadcast_message({
        source: WINDOW_EVENTS.CA_APP_LOGOUT,
      }, origin);
    }
    this.maybeRedirect();
  }

  maybeRedirect() {
    let query = this.props.location.search;
    if (!query) {
      return;
    }
    query = urlParamToObj(query);

    const { wlf_id, demo } = query;

    if (demo === "true") {
      this.props.appSetDemoMode(true);
    }

    if (wlf_id) {
      delete query.wlf_id;

      const wlfs = this.props.wlfs;

      const wlf = wlfs.find(wlf => wlf.id === wlf_id);

      if (wlf) {
        return this.gotoLandingPage(wlf, query)
      }
    }

    if (is_production_mode(this.props.app.config)) {
      console.log("PRODUCTION MODE", query);
      if (Object.keys(query).length > 0) {
        return this.props.navigatePath("/login" + objToUrlParam(query));
      }
    }

  }

  changeSelection = e => {
    const wlfId = e.target.value;
    const {wlfs} = this.props;
    const wlf = _.findWhere(wlfs, {id: wlfId});
    this.setState(
      {
        selectedWlf: wlf,
        users: [],
        wlf_admins: [],
        super_admins: [],
      }
    );

    getUsersForWlf(wlf.id)
      .then(items => {
        this.setState({
          users: items.users,
          wlf_admins: items.wlf_admin,
          super_admins: items.super_admin,
        });
      })
  }

  onSelect = ev => {
    ev.preventDefault();
    this.gotoLandingPage(this.state.selectedWlf, {});
  }

  gotoLandingPage = (selectedWlf, args) => {
    const cookies = new Cookies();
    cookies.set('wlf_id', selectedWlf.id, { path: '/' });
    let _config = null;
    const css_id = selectedWlf.id;
    this.props.appSetWlf(selectedWlf);
    loadCSS(css_id)
      .then(({ css, config} ) => {
      _config = config;
        return this.props.updateClient(css);
      })
      .then(() => {
        return this.props.appSetConfig(_config);
      })
      .then(() => {
        if (args.new_account_type) {
          return this.props.navigatePath("/new_account" + objToUrlParam(args));
        }
        return this.props.navigatePath("/login" + objToUrlParam(args));
      });
  };

  dumpSelectionBox = () => {

    const {wlfs} = this.props;
    const {selectedWlf} = this.state;

    return (
      <div className="box-container-responsive">
        <div className="box">
          <p className="subtitle has-text-grey">Please choose a White-Labeled Firm</p>

          <div className="select is-multiple client-select">
            <select size="4" onChange={this.changeSelection} value={selectedWlf.id}>
              {
                _.map(wlfs, (wlf, index) => {
                  return <option value={wlf.id} key={index}>{wlf.name}</option>
                })
              }
            </select>
        <nav className="nav-responsive">
            <button
                type={"button"}
                className={classNames("button client-select-btn")}>
                Cancel
              </button>
              <button
                type={"button"}
                className={classNames("button client-select-btn is-info")}
                disabled={!selectedWlf}
                onClick={this.onSelect}>
                Select
              </button>
          </nav>
          </div>
          
        </div>
      </div>
    )
  };

  dumpUsers = () => {

    const { super_admins, users, wlf_admins } = this.state;
    const numRow = Math.max(super_admins.length, users.length, wlf_admins.length, 1);
    const headerStyle = {
      width: "20rem",
    };
    const rows = [];
    const dumpItem = (items, index) => {
      if (items.length === 0 && index === 0) {
        return ( (
          <span>Empty</span>
        ))
      }

      if (index >= items.length) {
        return null;
      }
      return (
        <span>{items[index]}</span>
      )
    };

    for(let row = 0; row < numRow; row++) {
      rows.push( (
        <tr key={row}>
          <td>
            { dumpItem(users, row) }
          </td>
          <td>
            { dumpItem(wlf_admins, row) }
          </td>
          <td>
            { dumpItem(super_admins, row) }
          </td>
        </tr>
      ))
    }
    const style = {
      marginTop: "2rem",
      overflowX: "auto",
    };

    return (
      <div align="center" style={style}>
        <table className="table is-bordered">
          <thead>
            <tr>
              <th style={headerStyle}>Users:</th>
              <th style={headerStyle}>WLF Admin:</th>
              <th style={headerStyle}>Super Admin:</th>
            </tr>
          </thead>
          <tbody>
           { rows }
          </tbody>
        </table>
      </div>
    )
  };

  render() {
    
    return (
      <section className="login-page hero home-page">
        <div className="hero-body">
          <div className="has-text-centered">
            { this.dumpSelectionBox() }
            { this.dumpUsers() }
          </div>
        </div>
      </section>
    );
  }
}

export default Home;
